import React, { useState, useRef, useEffect } from 'react';
import HistoryModal from '../../History/HistoryModal';
import Modal from '../../Modal';
import {Cureus} from '../../../Cureus';

const InRereview = ({renderChevronContainer, articlesPath, initialData, createPath, templatePath, isParent, renderMailIcon}) => {

  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState(false);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchData();
  }, [expanded])

  const setColumns = () => {
    if(isParent) {
      return [
        {width: '35px'},
        {width: '160px'},
        null,
        {width: '160px'},
        {width: '160px'},
        null,
        {width: '160px', class: 'centered'},
        {width: '160px', class: 'centered'}
      ]
    } else {
      return [
        {width: '35px'},
        {width: '160px'},
        null,
        {width: '160px'},
        null,
        {width: '160px', class: 'centered'},
        {width: '160px', class: 'centered'}
      ]
    }
  }

  const mapColumns = (dt, row) => {
    if(isParent) {
      return (
        dt.fnAddData( [
          row.checkbox,
          row.entered_peer_review_on,
          row.sort_column,
          row.channel_name,
          row.submitting_author,
          row.title,
          row.review_status,
          row.reminder_history
      ], false)
      )
    } else {
      return (
        dt.fnAddData( [
          row.checkbox,
          row.entered_peer_review_on,
          row.sort_column,
          row.submitting_author,
          row.title,
          row.review_status,
          row.reminder_history
      ], false)
      )
    }
  }

  const setSorting = () => {
    if(isParent) {
      return {orderable: false, targets: [0, 7]}
    } else {
      return {orderable: false, targets: [0, 6]}
    }
  }

  const populateTable = (fetchedTableData) => {
    var dt = $("#in-rereview-table").DataTable({
      columns: setColumns(),
      columnDefs: [
        {targets: [1], orderData: [2]},
        {targets: [2], visible: false},
        setSorting()
      ],
      searching: false,
      "rowCallback": function(row) {
        let element = isParent ? row.children[6].children[0] : row.children[5].children[0]
        element.addEventListener('click',function() {
          openHistoryModal(element.dataset.articleId, element.dataset.authorshipId)
        })
      },
      dom: '<"row">tr<"row"<"large-8 columns pagination-details" <"pull-left"p><"pull-left showing-info"i>><"large-4 columns"<"text-right"l>>>',
      "fnDrawCallback": function(oSettings) {
        if (oSettings.fnRecordsDisplay() == 0) {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
          $(oSettings.nTableWrapper).find('.dataTables_length').hide();
          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
        } else if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        } else {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
          $(oSettings.nTableWrapper).find('.dataTables_length').show();
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        }
      }
    })
    
    dt.api().clear();
    for (var i = 0; i < fetchedTableData.articles.length; i++) {
      let row = fetchedTableData.articles[i];
      mapColumns(dt, row)
    }
    dt.fnSort([[2, 'desc']])
    dt.fnDraw()
    $(document).foundation('reflow');
    Cureus.Admin.MultipleReminders.init({
      btnSelector: "#in-rereview-row .bulk-email-button",
      noNavSelector: true,
      tabPaneSelector: "#in-rereview-datatable-container",
      templateName: "InRereview",
      templatePath: templatePath,
      createPath: createPath,
      async: true
    });

  }

  const fetchData = () => {
    if(tableData) {
      populateTable(tableData)
      return;
    }

    $.ajax({
      type: 'GET',
      url: articlesPath,
      data: {state: 'InRereview'},
      success: function(data) {
        setTableData(data)
        populateTable(data)
      }
    });
  }

  const openHistoryModal = (articleId, authorshipReviewershipId) => {
    Modal.open({
      children: <HistoryModal
          isAuthorship={true}
          articleId={articleId}
          authorshipReviewershipId={authorshipReviewershipId}
        />
    });
  }

  const renderHeaderRow = () => {
    return (
      <div className="row article-state-row" id="in-rereview-row">
        <div className="small-1 columns bubble-container has-tip tip-top" data-tooltip="" id="bubble-tooltip-editor-preview" title={initialData.tooltip}>
          <img src={`https://public.cureus.com/channel-icons/grey-bubble.png`} />
          <span className="bubble-text">{initialData.total}</span>
        </div>
        <div className="small-9 columns article-state-label">
          <h4>{initialData.label}</h4>  
          <span>{initialData.blurb}</span>
        </div>
        <div className="small-2 columns chevron-container">
          {renderChevronContainer(expanded, setExpanded, 'chevron-toggle-with-mail-icon')}
          {expanded && renderMailIcon("in-rereview")}
        </div>
      </div>
    )
  }

  const renderChannel = () => {
    if(isParent) {
      return <th>Channel</th>
    }
  }

  return (
    <React.Fragment>
      <div className="article-state-row-container">
        {renderHeaderRow()}
        {expanded && 
          <div className="channel-articles-datatable-container" id="in-rereview-datatable-container">
            <table id="in-rereview-table">
              <thead>
                <tr>
                  <th><input type="checkbox" /></th>
                  <th>Peer re-review start date</th>
                  <th></th>
                  {renderChannel()}
                  <th>Submitting author</th>
                  <th>Title</th>
                  <th>Review status</th>
                  <th>Reminder history</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        }        
      </div>

    </React.Fragment>
  )
}

export default InRereview;